import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { SoggettoResponsabile } from '../models';




@Injectable({
    providedIn: "root"
})
export class SoggettoResponsabileService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}SoggettiResponsabili/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<any>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<SoggettoResponsabile[]>(
            `${this.apiUrl}`            
        );
    }

    insert(s: SoggettoResponsabile) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: SoggettoResponsabile) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:SoggettoResponsabile){
        if (s.id)return this.update(s);
        return this.insert(s);
    }

    getAllBySottoTipologia(sottoTipologia) {
        return this.http.get<SoggettoResponsabile[]>(
            `${this.apiUrl}sottotipologia/${sottoTipologia}`            
        );
    }

}
